import api from '../../services/api';
import Cookies from 'universal-cookie';

const AssinaHolerite = (tipo, data ) => {

    const cookies = new Cookies();
    
    console.log(  tipo, data )

    const tipo_proces = tipo
    const cpf = cookies.get('ckCPF')
    const data_comp =  data.replace(/\//g,"-")
    
    console.log( cpf, tipo_proces, data_comp )

    api.get(`/datasnap/rest/tsm/AssHoler("${cpf}","${data_comp}","${tipo_proces}")`)
            .then(resp => {
                console.log(resp.data.result[0])
                window.location.reload()
             })
}

export default AssinaHolerite